import SVGImg from './scan-outline-svgrepo-com.web.svg'

const ScanOutline = () => {
  return <SVGImg width={390} height={390} stroke="#FFFFFF" />
}

export default ScanOutline
